const fileType = function (type, size) {
    const data = {
        doc: require('@/assets/img/resource-type/doc.png'),
        xls: require('@/assets/img/resource-type/EXCEL.png'),
        ppt: require('@/assets/img/resource-type/PPT.png'),
        pptx: require('@/assets/img/resource-type/PPT.png'),
        img: require('@/assets/img/resource-type/img.png'),
        files: require('@/assets/img/resource-type/files.png'),
        pdf: require('@/assets/img/resource-type/pdf.png'),
        audio: require('@/assets/img/resource-type/audio.png'),
        video: require('@/assets/img/resource-type/video.png'),
        rest: require('@/assets/img/resource-type/rest.png')
    };
    const data2 = {
        doc: require('@/assets/img/doc-type/doc@2x.png'),
        xls: require('@/assets/img/doc-type/excel@2x.png'),
        ppt: require('@/assets/img/doc-type/ppt@2x.png'),
        pptx: require('@/assets/img/doc-type/ppt@2x.png'),
        img: require('@/assets/img/doc-type/img@2x.png'),
        files: require('@/assets/img/doc-type/files@2x.png'),
        pdf: require('@/assets/img/doc-type/pdf@2x.png'),
        audio: require('@/assets/img/doc-type/audio@2x.png'),
        video: require('@/assets/img/doc-type/video@2x.png'),
        rest: require('@/assets/img/doc-type/rest@2x.png')
    };
    if (size) {
        return data2[type] ? data2[type] : data2.rest;
    } else {
        return data[type] ? data[type] : data.rest;
    }
};
const CommonFileType = function (type, size) {
    const data = {
        doc: require('@/assets/img/home/doc-type/doc.png'),
        xls: require('@/assets/img/home/doc-type/doc.png'),
        ppt: require('@/assets/img/home/doc-type/doc.png'),
        pptx: require('@/assets/img/home/doc-type/doc.png'),
        img: require('@/assets/img/home/doc-type/img.png'),
        files: require('@/assets/img/home/doc-type/files.png'),
        pdf: require('@/assets/img/home/doc-type/pdf.png'),
        audio: require('@/assets/img/home/doc-type/audio.png'),
        video: require('@/assets/img/home/doc-type/video.png'),
        rest: require('@/assets/img/home/doc-type/rest.png')
    };
    const data2 = {
        doc: require('@/assets/img/home/doc-type/doc@2x.png'),
        xls: require('@/assets/img/home/doc-type/doc@2x.png'),
        ppt: require('@/assets/img/home/doc-type/doc@2x.png'),
        pptx: require('@/assets/img/home/doc-type/doc@2x.png'),
        img: require('@/assets/img/home/doc-type/img@2x.png'),
        files: require('@/assets/img/home/doc-type/rest@2x.png'),
        pdf: require('@/assets/img/home/doc-type/pdf@2x.png'),
        audio: require('@/assets/img/home/doc-type/audio@2x.png'),
        video: require('@/assets/img/home/doc-type/video@2x.png'),
        rest: require('@/assets/img/home/doc-type/rest@2x.png')
    };
    if (size) {
        return data2[type] ? data2[type] : data2.rest;
    } else {
        return data[type] ? data[type] : data.rest;
    }
};
const routeInfo = {
    'resource-home': {
        name: '资源广场',
        path: '/idx/resource/square'
    },
    'my-resource': {
        name: '个人中心',
        path: '/idx/userCenter/resource'
    },
   
};

export { fileType, CommonFileType, routeInfo };
